export const PROJECTS = "projects";
export const ABOUT = "about";
export const CONTACT = "contact";
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;